import './xy-legend.css';
export var shapeIconWrapper = '_1lwufqz0-3-8-0';